import {CommonNs} from '@shared/types/common.namespace';
import {WorkspaceNs} from '@shared/types/workspace.namespace';

export namespace AccountNs {

    /** Account Routes */
    export enum AccountRouteEnums {
        ACCOUNT = 'Account',
        PROFILE = 'AccountProfile',
        EMAIL = 'AccountEmail',
        PASSWORD = 'AccountPassword',
        CONNECTIONS = 'AccountConnections',
        GENERAL_PAGE = 'AccountGeneralPage',
        GENERAL = 'AccountGeneral',
        LEAVE_WORKSPACE = 'AccountGeneralWorkspaceLeave',
        DELETE_WORKSPACE = 'AccountGeneralWorkspaceDelete',
        LOGINACTIVITY = 'AccountGeneralLoginActivity',
        DANGERZONE = 'AccountGeneralDangerZone'
    }

    export enum PropertyEnums {
        FIRST_NAME = 'firstName',
        LAST_NAME = 'lastName',
        PRIMARY_EMAIL = 'primaryEmail',

        POSITION = 'title',
        CITY = 'city',
        COUNTRY = 'country',

        PHONE = 'phone',
        MOBILE = 'mobile',
        EMAIL = 'email',
        WEBSITE = 'website',

        LINKEDIN = 'linkedin',
        FACEBOOK = 'facebook',
        INSTAGRAM = 'instagram',
        TWITTER = 'twitter',
        YOUTUBE = 'youtube',
        WHATSAPP = 'whatsapp',
        TELEGRAM = 'telegram',

        BIO = 'bio',
        SKILL = 'skill',
        LANGUAGE = 'language',
        HOURLY_RATE = 'hourly_rate',
        DAILY_RATE = 'daily_rate',

        CUSTOM = 'custom',
    }

    export interface Account {
        profileCover: string,
        fullNamePermission: string,
        primaryEmailPermission: string,
        accountProperties?: AccountProperty[],
    }

    export interface AccountProperty {
        name: string,
        label: string,
        type: string,
        isCustom: boolean,
        inputValue: any,
        permission: CommonNs.PermissionsEnums,
        icon: string,
        iconType: string,
    }

    export interface UpdateAccountPropertyRequest {
        firstName: string,
        lastName: string,
        accountProperties?: AccountProperty[],
    }

    /** Change Primary Email */
    export interface ChangePrimaryEmailRequest {
        newEmail: string,
        password: string
    }

    /** Change Password */
    export interface ChangePasswordRequest {
        newPassword: string,
        password: string
    }

    /** General User Info */
    export interface GeneralInfo {
        language: string,
        timezone: string,
        isTimeZoneAutomatic: boolean,
        newsletter: boolean,
        workspaces: WorkspaceNs.Workspace[],
    }

    /** General User Info */
    export interface UpdateGeneralInfoRequest {
        language: string,
        timezone: string,
        isTimeZoneAutomatic: boolean,
        newsletter: boolean,
    }

    /** General Info - Workspace Route Meta Data */
    export interface WorkspaceRouteMetaData {
        mode: 'LEFT' | 'DELETE',
    }

    /** General - Danger Zone - Delete Account */
    export interface DeleteAccountRequest {
        password: string,
        typeDelete: string,
    }

    /** Confirm Account Deletion */
    export interface ConfirmDeleteAccountRequest {
        confirmationCode: string,
        userId: string,
    }

    /** User Login Activity */
    export interface LoginActivity {
        id: string,
        device: string,
        fullLocation: string,
        ipAddress: string,
        date: Date,
    }

}
